(function() {
  'use strict';
  
  function initParametersStructure() {
    const variantsEl = document.querySelector('[data-variants]');
    if (!variantsEl) return false;
    
    const section = variantsEl.closest('.shopify-section');
    const accordionRows = section ? section.querySelectorAll('accordion-custom') : document.querySelectorAll('accordion-custom');
    
    let parametersRow = null;
    for (const row of accordionRows) {
      const summary = row.querySelector('summary.details__header');
      if (summary && summary.textContent.trim().includes('Parameters')) {
        parametersRow = row;
        break;
      }
    }
    
    if (!parametersRow) return false;
    
    parametersRow.classList.add('product-parameters');
    const detailsContent = parametersRow.querySelector('.details-content');
    if (!detailsContent) return false;
    
    if (detailsContent.querySelector('.parameters-list')) {
      return true;
    }
    
    const staticHTML = `
      <div class="parameters-list">
        <div class="parameter-item" data-param="size">
          <span class="parameter-label">Size</span>
          <span class="parameter-value skeleton"></span>
        </div>
        <div class="parameter-item" data-param="material">
          <span class="parameter-label">Material</span>
          <span class="parameter-value skeleton"></span>
        </div>
        <div class="parameter-item" data-param="collection">
          <span class="parameter-label">Collection</span>
          <span class="parameter-value skeleton"></span>
        </div>
        <div class="parameter-item" data-param="brand">
          <span class="parameter-label">Brand</span>
          <span class="parameter-value skeleton"></span>
        </div>
        <div class="parameter-item" data-param="sku">
          <span class="parameter-label">SKU</span>
          <span class="parameter-value skeleton"></span>
        </div>
      </div>
    `;
    
    const textBlock = detailsContent.querySelector('p, [class*="text"], .rte');
    if (textBlock) {
      textBlock.innerHTML = staticHTML;
    } else {
      detailsContent.innerHTML = staticHTML;
    }
    
    return true;
  }
  
  function updateParameterValues(params) {
    const variantsEl = document.querySelector('[data-variants]');
    if (!variantsEl) return;
    
    const section = variantsEl.closest('.shopify-section');
    const accordionRows = section ? section.querySelectorAll('accordion-custom') : document.querySelectorAll('accordion-custom');
    
    let parametersRow = null;
    for (const row of accordionRows) {
      const summary = row.querySelector('summary.details__header');
      if (summary && summary.textContent.trim().includes('Parameters')) {
        parametersRow = row;
        break;
      }
    }
    
    if (!parametersRow) return;
    
    const detailsContent = parametersRow.querySelector('.details-content');
    if (!detailsContent) return;
    
    const { size, material, brand, collection, sku } = params;
    
    const sizeItem = detailsContent.querySelector('[data-param="size"]');
    if (sizeItem) {
      const sizeValue = sizeItem.querySelector('.parameter-value');
      if (sizeValue) {
        sizeItem.style.display = size ? 'flex' : 'none';
        sizeValue.textContent = size || '';
        sizeValue.classList.remove('skeleton');
      }
    }
    
    const materialItem = detailsContent.querySelector('[data-param="material"]');
    if (materialItem) {
      const materialValue = materialItem.querySelector('.parameter-value');
      if (materialValue) {
        materialItem.style.display = material ? 'flex' : 'none';
        materialValue.textContent = material || '';
        materialValue.classList.remove('skeleton');
      }
    }
    
    const collectionItem = detailsContent.querySelector('[data-param="collection"]');
    if (collectionItem) {
      const collectionValue = collectionItem.querySelector('.parameter-value');
      if (collectionValue) {
        if (collection && collection.title) {
          collectionItem.style.display = 'flex';
          collectionValue.innerHTML = `<a href="${collection.url || '#'}" class="collection-link collection-link-multiline">${collection.title}</a>`;
        } else {
          collectionItem.style.display = 'none';
          collectionValue.innerHTML = '';
        }
        collectionValue.classList.remove('skeleton');
      }
    }
    
    const brandItem = detailsContent.querySelector('[data-param="brand"]');
    if (brandItem) {
      const brandValue = brandItem.querySelector('.parameter-value');
      if (brandValue) {
        brandItem.style.display = brand ? 'flex' : 'none';
        brandValue.textContent = brand || '';
        brandValue.classList.remove('skeleton');
      }
    }
    
    const skuItem = detailsContent.querySelector('[data-param="sku"]');
    if (skuItem) {
      const skuValue = skuItem.querySelector('.parameter-value');
      if (skuValue) {
        skuItem.style.display = sku ? 'flex' : 'none';
        skuValue.textContent = sku || '';
        skuValue.classList.remove('skeleton');
      }
    }
  }
  
  function updateParameters(variantId, fullVariantData) {
    try {
      const variantsEl = document.querySelector('[data-variants]');
      if (!variantsEl) {
        return;
      }
      
      const variants = JSON.parse(variantsEl.textContent || '[]');
      const variant = variants.find(v => String(v.id) === String(variantId));
      if (!variant) {
        return;
      }
      
      // Объединяем данные из [data-variants] с полными данными варианта
      // Приоритет у полных данных (fullVariantData), затем данные из [data-variants]
      const variantWithFullData = fullVariantData ? { ...variant, ...fullVariantData } : variant;
      
      if (!initParametersStructure()) {
        return;
      }
      
      const selectedSize = getSelectedSize();
      const productMetafields = getProductMetafields();
      const collectionData = getCollectionData();
      
      let sizeValue = '';
      if (variant.size && variant.size !== null && String(variant.size).trim() !== '' && variant.size !== '0') {
        sizeValue = variant.size;
      } else if (selectedSize && selectedSize !== '0') {
        sizeValue = selectedSize;
      } else if (productMetafields.size && productMetafields.size !== '3' && productMetafields.size !== '0' && productMetafields.size.trim() !== '') {
        sizeValue = productMetafields.size;
      }
      
      const materialValue = (variant.material && variant.material !== null && String(variant.material).trim() !== '') 
        ? variant.material 
        : (productMetafields.material || '');
      
      const brandValue = (variant.brand && variant.brand !== null && String(variant.brand).trim() !== '') 
        ? variant.brand 
        : (productMetafields.brand || '');
      
      const skuValue = variant.sku && String(variant.sku).trim() !== '' 
        ? String(variant.sku).trim() 
        : '';
      
      updateParameterValues({
        size: sizeValue,
        material: materialValue,
        brand: brandValue,
        collection: collectionData,
        sku: skuValue
      });
      
      // Обновляем кнопку преордера
      updateMobileBarButton(variantWithFullData);
      
    } catch (error) {
      console.error('Error updating parameters:', error);
    }
  }
  
  function updateInventoryFromHTML(htmlData) {
    if (!htmlData) return;
    
    // Ищем product-inventory-badges-container в текущем DOM
    const currentContainer = document.querySelector('.product-inventory-badges-container');
    if (!currentContainer) return;
    
    // Ищем product-inventory-badges-container в новом HTML
    // Может быть в блоке _product-details или в блоке product-inventory
    const newContainer = htmlData.querySelector('.product-inventory-badges-container');
    if (!newContainer) {
      // Попробуем найти product-inventory напрямую
      const newInventory = htmlData.querySelector('product-inventory');
      const currentInventory = currentContainer.querySelector('product-inventory');
      if (newInventory && currentInventory) {
        currentInventory.outerHTML = newInventory.outerHTML;
        return;
      }
      return;
    }
    
    // Заменяем содержимое контейнера
    currentContainer.innerHTML = newContainer.innerHTML;
  }
  
  function updateButtonFromHTML(htmlData) {
    if (!htmlData) return;
    
    // Ищем product-details-cart-button-wrapper в новом HTML
    const newButtonWrapper = htmlData.querySelector('.product-details-cart-button-wrapper');
    if (!newButtonWrapper) return;
    
    // Ищем текущий контейнер на ПК
    const currentDesktopContainer = document.querySelector('.add-to-cart-button--desktop');
    if (!currentDesktopContainer) return;
    
    const currentButtonWrapper = currentDesktopContainer.querySelector('.product-details-cart-button-wrapper');
    if (!currentButtonWrapper) return;
    
    // Заменяем содержимое обертки кнопки
    currentButtonWrapper.innerHTML = newButtonWrapper.innerHTML;
  }
  
  function updateMobileBarButton(variant) {
    if (!variant) return;
    
    updateButtonInContainer('[data-mobile-bar]', variant);
    updateButtonInContainer('.product-details-cart-button-wrapper', variant);
  }
  
  function updateButtonInContainer(containerSelector, variant) {
    const container = document.querySelector(containerSelector);
    if (!container) return;
    
    const wrapper = container.querySelector('.mobile-product-bar__add-button-wrapper');
    const button = container.querySelector('.mobile-product-bar__add-button');
    
    if (!wrapper || !button) return;
    
    wrapper.dataset.variantId = variant.id;
    button.dataset.variantId = variant.id;
  }
  
  function getInventoryStatus(variant) {
    if (!variant) return 'out_of_stock';
    
    // Если есть полные данные варианта с inventory_management
    if (variant.inventory_management !== undefined) {
      if (variant.inventory_management === 'shopify') {
        const quantity = variant.inventory_quantity || 0;
        if (quantity > 0) {
          if (quantity <= 10) {
            return 'low';
          }
          return 'in_stock';
        } else {
          if (variant.inventory_policy === 'continue') {
            return 'in_stock';
          }
          return 'out_of_stock';
        }
      } else {
        return variant.available ? 'in_stock' : 'out_of_stock';
      }
    }
    
    // Если нет данных об inventory, используем available
    return variant.available ? 'in_stock' : 'out_of_stock';
  }
  
  function getSelectedSize() {
    try {
      const section = document.querySelector('[data-variants]')?.closest('.shopify-section');
      const variantPicker = section ? section.querySelector('variant-picker') : document.querySelector('variant-picker');
      
      if (variantPicker) {
        const sizeOptions = variantPicker.querySelectorAll('[data-option="Size"], [data-option="size"]');
        for (const option of sizeOptions) {
          if (option.matches('input:checked, option:selected, .selected, [aria-selected="true"]')) {
            return option.dataset.value || option.textContent?.trim();
          }
        }
      }
      return null;
    } catch (error) {
      return null;
    }
  }
  
  function getProductMetafields() {
    try {
      const section = document.querySelector('[data-variants]')?.closest('.shopify-section');
      return {
        size: section?.querySelector('[data-product-size]')?.value?.trim() || '',
        material: section?.querySelector('[data-product-material]')?.value?.trim() || '',
        brand: section?.querySelector('[data-product-brand]')?.value?.trim() || ''
      };
    } catch (error) {
      return {};
    }
  }
  
  function getCollectionData() {
    try {
      const section = document.querySelector('[data-variants]')?.closest('.shopify-section');
      const title = section?.querySelector('[data-collection-title]')?.value?.trim() || '';
      const url = section?.querySelector('[data-collection-url]')?.value?.trim() || '';
      
      if (title && title !== '' && title !== '#') {
        return {
          title: title,
          url: url || '#'
        };
      }
      return null;
    } catch (error) {
      return null;
    }
  }
  
  function init() {
    document.addEventListener('variant:changed', (e) => {
      if (e.detail?.variant) {
        updateParameters(e.detail.variant.id, e.detail.variant);
      }
    });
    
    document.addEventListener('variant:update', (e) => {
      if (e.detail?.resource) {
        // Используем полный объект варианта из события
        updateParameters(e.detail.resource.id, e.detail.resource);
        
        // Обновляем inventory из HTML события
        if (e.detail?.data?.html) {
          updateInventoryFromHTML(e.detail.data.html);
          // Обновляем кнопку на ПК из HTML
          updateButtonFromHTML(e.detail.data.html);
        }
        
        // Обновляем кнопку преордера (мобильный бар и ПК через JS)
        updateMobileBarButton(e.detail.resource);
      }
    });
    
    document.addEventListener('change', (e) => {
      if (e.target.closest('variant-picker')) {
        const variantId = e.target.dataset.variantId || e.target.value;
        if (variantId) {
          // Пытаемся получить полные данные варианта из variant-picker
          const fullVariant = getFullVariantData(variantId);
          updateParameters(variantId, fullVariant);
        }
      }
    });
    
    const currentVariantId = new URLSearchParams(window.location.search).get('variant') || 
                            document.querySelector('input[name="id"]')?.value;
    if (currentVariantId) {
      requestAnimationFrame(() => {
        const fullVariant = getFullVariantData(currentVariantId);
        updateParameters(currentVariantId, fullVariant);
      });
    } else {
      requestAnimationFrame(() => {
        const variantsEl = document.querySelector('[data-variants]');
        if (variantsEl) {
          const variants = JSON.parse(variantsEl.textContent || '[]');
          if (variants.length > 0) {
            const fullVariant = getFullVariantData(variants[0].id);
            updateParameters(variants[0].id, fullVariant);
          }
        }
      });
    }
  }
  
  function getFullVariantData(variantId) {
    try {
      // Пытаемся получить полные данные варианта из variant-picker
      const variantPicker = document.querySelector('variant-picker');
      if (variantPicker) {
        const scriptEl = variantPicker.querySelector('script[type="application/json"]');
        if (scriptEl) {
          const fullVariant = JSON.parse(scriptEl.textContent || '{}');
          if (fullVariant && String(fullVariant.id) === String(variantId)) {
            return fullVariant;
          }
        }
      }
      
      // Если не нашли, возвращаем null
      return null;
    } catch (e) {
      return null;
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  document.addEventListener('shopify:section:load', init);
})();
